import { render, staticRenderFns } from "./buySameGet.vue?vue&type=template&id=d0fffa3c&"
import script from "./buySameGet.vue?vue&type=script&lang=js&"
export * from "./buySameGet.vue?vue&type=script&lang=js&"
import style0 from "./buySameGet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports